export const CollectionView = {
  state: {
    collection: null,
  },

  getters: {
    getCollection: (state) => {
      return state.collection;
    },
  },

  mutations: {
    setCollection(state, collection) {
      state.collection = collection;
    },
  },

  actions: {
    async requestCollection({ commit }, slug) {
      commit('setBusy', true);
      try {
        const response = await this._vm.$api('case.collection.get', {
          version: '1.0',
          caseCollection: slug,
        });
        commit('setCollection', response.data.data);
      } catch (err) {
        window.location.href = '/home';
      }
      commit('setBusy', false);
    },
  },
};
